import React from 'react';
import { TEXT_COLOR_FOR_CHART_SVG } from '../../chartConsts';
type Abbreviations = {
  [key: number]: string;
};
type ChartVerticalAxisTickProps = {
  x: number;
  y: number;
  textAnchor: string;
  payload: {
    value: number;
  };
  shouldNormalize: boolean | undefined;
};

export const ChartVerticalAxisTickView = (props: ChartVerticalAxisTickProps) => {
  const { x, y, payload, textAnchor, shouldNormalize } = props;
  const abbreviations: Abbreviations = {
    1000: 'k',
    1000000: 'M',
    1000000000: 'b'
  };
  const tickValue = payload.value;
  const absTick = Math.abs(tickValue);
  const key = Object.keys(abbreviations)
    .map(Number)
    .sort((a, b) => b - a) // We need to sort in descending order
    .find(k => absTick >= k);
  const plusSign = tickValue >= 0 ? '+' : '';
  if (key) {
    const abbreviation = abbreviations[Number(key)];
    const tickValueToDisplay = tickValue / Number(key);
    const shouldShowDecimal = tickValueToDisplay % 1 !== 0;

    if (shouldNormalize) {
      return (
        <g transform={`translate(${x},${y})`}>
          <text opacity={0.85} textAnchor={textAnchor} fill={TEXT_COLOR_FOR_CHART_SVG}>
            {`${
              shouldShowDecimal
                ? `${plusSign}${tickValueToDisplay.toFixed(1)}`
                : `${plusSign}${tickValueToDisplay.toFixed(0)}`
            }${abbreviation}%`}
          </text>
        </g>
      );
    }
    return (
      <g transform={`translate(${x},${y})`}>
        <text opacity={0.85} textAnchor={textAnchor} fill={TEXT_COLOR_FOR_CHART_SVG}>
          {`${shouldShowDecimal ? tickValueToDisplay.toFixed(2) : tickValueToDisplay.toFixed(0)}${abbreviation}
          `}
        </text>
      </g>
    );
  }
  return (
    <g transform={`translate(${x},${y})`}>
      <text dy={5} opacity={0.85} textAnchor={textAnchor} fill={TEXT_COLOR_FOR_CHART_SVG}>
        {shouldNormalize ? `${plusSign}${tickValue}%` : tickValue}
      </text>
    </g>
  );
};
